import { getFileExtension, getFileName } from "../file/filePath";

export interface FileInfo {
    path: string;
    name: string;
    extension: string;
}

export const getFileInfo = (path: string): FileInfo => ({
    path,
    name: getFileName(path),
    extension: getFileExtension(path)
});
